<script setup lang="ts"></script>

<template><img src="../../../assets/flags/se.svg" /></template>
